import { render, staticRenderFns } from "./IconColorSwatchOutline.vue?vue&type=template&id=8857a85c"
import script from "./IconColorSwatchOutline.vue?vue&type=script&lang=js"
export * from "./IconColorSwatchOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports